const initialState = {
  jobOpportunities: null,
  search: "",
};

const supplementsReducer = (state = initialState, action) => {
  switch (action.type) {
    //!customers
    case "FETCH_SPECIFIC_ADMINISTRATION_PROPERTY": {
      // if(action.property===)
      return {
        ...state,
        [action.property]: action.data,
      }
    };

    case "CREATE_SPECIFIC_ADMINISTRATION_PROPERTY": {
      const dt = state[action.property].concat(action.data);
      return {
        ...state,
        [action.property]: dt,
      };
    }
    case "DELETE_SPECIFIC_ADMINISTRATION_PROPERTY": {
      const dt = state[action.property].filter((a) => a._id !== action.id);
      return {
        ...state,
        [action.property]: dt,
      };
    }
    case "UPDATE_SPECIFIC_ADMINISTRATION_PROPERTY": {
      let dt = state[action.property].map((order) => {
        if (order._id === action.data._id) {
          return action.data;
        }
        return order;
      });
      return {
        ...state,
        [action.property]: dt,
      };
    }

    case "UPDATE_ADMINISTRATION_SEARCH": {
      return {
        ...state,
        search: action.data,
      };
    }
    default:
      return state;
  }
};

export default supplementsReducer;
